module.exports = __webpack_public_path__ + "static/media/Phone-white.6f7f05ae.svg";